import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useApplicationMix');

    return {
        ATTACH_FAILED: t('attachFailed'),
        CONNECTION_ERROR: t('connectionError'),
        DETACH_FAILED: t('detachFailed')
    };
};

export default useTranslation;
